module.exports = __webpack_public_path__ + "assets/icons/jolt_24px.svg";